import { defineComponent as _defineComponent } from 'vue'
import { Carousel, Slide, Navigation } from "vue3-carousel";

  import { ref, computed } from "vue";
  import UpgradeOption from "./UpgradeOption.vue";
  import type { OptionalUpgrade } from "@/types/OptionalUpgradeInterface";
  import BuilderEstimatorStepTitle from "./BuilderEstimatorStepTitle.vue";
  import { useIsDesktop } from "@/features/useIsDesktop";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorHouseUpgradeOptionDesktop',
  props: {
    optionalUpgrades: {},
    selectedUpgradeFromForm: {},
    handleUpgradeSelection: { type: Function }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const { isDesktop: isTabletBreakpoint } = useIsDesktop(990);
  const { isDesktop: isLargeScreenBreakpoint } = useIsDesktop(1366);

  const props = __props;

  const carousel = ref(null);
  const itemsToShow = computed(() => {
    const ITEMS_TO_SHOW_DESKTOP = 4;
    const ITEMS_TO_SHOW_LAPTOP = 3;

    if (isTabletBreakpoint.value) {
      return isLargeScreenBreakpoint.value
        ? ITEMS_TO_SHOW_DESKTOP
        : ITEMS_TO_SHOW_LAPTOP;
    }

    return ITEMS_TO_SHOW_DESKTOP;
  });

const __returned__ = { isTabletBreakpoint, isLargeScreenBreakpoint, props, carousel, itemsToShow, get Carousel() { return Carousel }, get Slide() { return Slide }, get Navigation() { return Navigation }, ref, computed, UpgradeOption, BuilderEstimatorStepTitle, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})